import { Button } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

const HoldingsButton: React.FC = () => {
  return (
    <Button component={Link} to={'/entity'} variant="outlined">
      Holdings
    </Button>
  )
}

export default HoldingsButton
